var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-item", {
    attrs: {
      label: _vm.$t("推送方式")
    }
  }, [_c("a-radio-group", {
    attrs: {
      "button-style": "solid"
    },
    model: {
      value: _vm.tabValue,
      callback: function ($$v) {
        _vm.tabValue = $$v;
      },
      expression: "tabValue"
    }
  }, [_c("a-radio-button", {
    staticClass: "marginR15 custom-style",
    attrs: {
      value: "INTERNAL_MAIL"
    }
  }, [_vm._v(_vm._s(_vm.$t("站内信")))]), _c("a-radio-button", {
    staticClass: "marginR15 custom-style",
    attrs: {
      value: "NOTE"
    }
  }, [_vm._v(_vm._s(_vm.$t("短信")))]), _c("a-radio-button", {
    staticClass: "marginR15 custom-style",
    attrs: {
      value: "EMAIL"
    }
  }, [_vm._v(_vm._s(_vm.$t("邮件")))])], 1)], 1), _c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "right",
      "label-col": {
        span: 5
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("客户名称"),
      prop: "customerId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("客户名称"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customersList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.name === "系统管理员" ? _vm.$t("系统管理员") : item.name) + " ")]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("接收对象"),
      prop: "userName"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("接收对象"),
      allowClear: ""
    },
    model: {
      value: _vm.form.userName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userName", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.userName"
    }
  })], 1)], 1), _vm.tabValue === "NOTE" ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("手机号"),
      prop: "mobile"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("手机号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobile", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.mobile"
    }
  })], 1)], 1) : _vm._e(), _vm.tabValue === "INTERNAL_MAIL" ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("阅读状态"),
      prop: "readingStatus"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("阅读状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.readingStatus,
      callback: function ($$v) {
        _vm.$set(_vm.form, "readingStatus", $$v);
      },
      expression: "form.readingStatus"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("已读")))]), _c("a-select-option", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(_vm._s(_vm.$t("未读")))])], 1)], 1)], 1) : _vm._e(), _vm.tabValue === "EMAIL" ? _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("邮箱"),
      prop: "email"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("邮箱"),
      allowClear: ""
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1) : _vm._e(), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("消息类别")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("消息类别"),
      allowClear: ""
    },
    on: {
      change: _vm.flowTypeIdChange
    },
    model: {
      value: _vm.form.messageCategory,
      callback: function ($$v) {
        _vm.$set(_vm.form, "messageCategory", $$v);
      },
      expression: "form.messageCategory"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "AUDIT_FLOW"
    }
  }, [_vm._v(_vm._s(_vm.$t("审核流相关")))]), _c("a-select-option", {
    attrs: {
      value: "INSURE"
    }
  }, [_vm._v(_vm._s(_vm.$t("投保相关")))]), _c("a-select-option", {
    attrs: {
      value: "TASK_LIST"
    }
  }, [_vm._v(_vm._s(_vm.$t("任务列表相关")))]), _c("a-select-option", {
    attrs: {
      value: "SURRENDER_INSURANCE"
    }
  }, [_vm._v(_vm._s(_vm.$t("退保相关")))]), _c("a-select-option", {
    attrs: {
      value: "SYSTEM_MESSAGES"
    }
  }, [_vm._v(_vm._s(_vm.$t("系统消息")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("推送场景")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.pushScenarioPlaceholder,
      allowClear: "",
      disabled: !_vm.form.messageCategory
    },
    model: {
      value: _vm.form.pushScenario,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pushScenario", $$v);
      },
      expression: "form.pushScenario"
    }
  }, _vm._l(_vm.pushScenarioList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.pushScenario
      }
    }, [_vm._v(_vm._s(_vm.$t(item.pushScenarioName)))]);
  }), 1)], 1)], 1)], 1), _c("div", {
    staticClass: "marginT10"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))])], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.computedColumns,
      "data-source": _vm.dataSource,
      pagination: _vm.pagination,
      rowKey: "index"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "readingStatus",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text === 1 ? _vm.$t("已读") : _vm.$t("未读")) + " ")];
      }
    }, {
      key: "customerRender",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text ? _vm.$t(text) : "-") + " ")];
      }
    }, {
      key: "customerEmpty",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text ? text : "-") + " ")];
      }
    }, {
      key: "customerName",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(text ? text.replace("系统管理员", _vm.$t("系统管理员")).replace("全部", _vm.$t("全部")) : "-") + " ")];
      }
    }, {
      key: "sendStatus",
      fn: function (text, record) {
        return [_vm._v(" " + _vm._s(text === "SUCCESS" ? _vm.$t("发送成功") : text === "FAIL" ? _vm.$t("发送失败") : "-") + " "), text === "FAIL" ? _c("a-tooltip", {
          attrs: {
            title: _vm.$t(record.failureReason),
            placement: "topLeft"
          }
        }, [_c("a-icon", {
          staticStyle: {
            cursor: "pointer"
          },
          attrs: {
            type: "question-circle"
          }
        })], 1) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3, _item$slots4;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title) === "模板ID" ? _vm.$t("模板") + "ID" : _vm.$t((_item$slots4 = item.slots) === null || _item$slots4 === void 0 ? void 0 : _item$slots4.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };